import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header/Header";
import ProfileDetails from "../../components/ProfileDetails/ProfileDetails";
import NoImage from "../../components/NoImage/NoImage";
import { Observer, observer } from "mobx-react-lite";
import { isTablet } from "react-device-detect";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import { getDecodedToken, logEvents, trackEvent } from "../../utils/functions";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ProfileStore2 from "../../store/ProfileStore2";
import PerformanceStore from "../../store/PerformanceStore";
import { useLayoutEffect } from "react";
import { getCookie } from "../../utils/cookie";
import { PROFILE_PAGE } from "../../utils/constants";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
const Profile = () => {
  const [selectedData, setSelectedData] = useState({});
  const [currentOpenAccordion, setCurrentOpenAccordion] = useState("");
  const [currenAccordionObject, setCurrenAccordionObject] = useState({});
  const [selectedSet, setSelectedSet] = useState({
    userId: "",
    name: "",
    index: "",
    liaisonId: "",
  });
  const [loading, setLoading] = useState(true);
  const [scrollPoint, setScrollPoint] = useState(0);
  const ref = useRef(null);
  const userHydrated = UserStore.isHydrated;
  const mapUsersData = ProfileStore2.mapUsersData;

  const handleSelection = (user_id, name, la_officerId, data, index) => {
    const localData = data;
    setSelectedSet({
      userId: user_id,
      name: name,
      index: index,
      liaisonId: la_officerId,
    });
    ProfileStore2.secondTimeCall(user_id, index, la_officerId);
    handleAccordion("");
    setSelectedData(localData);
  };

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    PerformanceStore.setLoaderClosingCheck({});
  }, []);

  useEffect(() => {
    if (UserStore.isHydrated) {
      setLoading(false);
      if (getDecodedToken()?.user_type !== "manager") {
        if (
          getCookie("isSelectedUserPrimary") === "true" ||
          getDecodedToken()?.primary === "true"
        ) {
          window.scrollTo(0, 0);
          PerformanceStore.setCurrentLoader("fullScreen");
          AuthStore.updateLoadingFullScreen(true);
          ProfileStore2.getFamilyClients("profile");
        } else {
          window.scrollTo(0, 0);
          PerformanceStore.setCurrentLoader("fullScreen");
          AuthStore.updateLoadingFullScreen(true);
          ProfileStore2.getFamilyClients("nonPrimaryProfile");
        }
      } else {
        const user_id = getCookie("userid");
        setSelectedSet({
          userId: user_id,
          name: UserStore?.userData?.full_name,
          index: 0,
          liaisonId: UserStore?.userData?.liasonOfficers?.[0]?.liasonOfficerId,
        });

        ProfileStore2.getImage(
          UserStore.userData?.profile_pic
            ? UserStore.userData?.profile_pic
            : "",
          "normal"
        );
        let arr = [];
        arr.push(UserStore.userData);
        window.scrollTo(0, 0);
        PerformanceStore.setCurrentLoader("fullScreen");
        AuthStore.updateLoadingFullScreen(true);
        ProfileStore2.callForNonPrimary(
          getCookie("userid"),
          UserStore.userData?.liasonOfficers?.[0]?.liasonOfficerId,
          arr
        );
      }
    }
  }, [userHydrated]);

  useEffect(() => {
    if (ProfileStore2.mapUsersData?.length !== 0) {
      const user_id = ProfileStore2?.mapUsersData?.[0]?.user_id;

      setSelectedSet({
        userId: user_id,
        name: ProfileStore2?.mapUsersData?.[0]?.full_name,
        index: 0,
        liaisonId:
          ProfileStore2?.mapUsersData?.[0]?.liasonOfficers?.[0]
            ?.liasonOfficerId,
      });
    }
  }, [mapUsersData]);

  useEffect(() => {
    trackEvent(PROFILE_PAGE);
    logEvents(PROFILE_PAGE);
  }, []);

  const handleAccordion = (data) => {
    setCurrentOpenAccordion(data);
  };

  function handleScrollStart() {
    const scrollTop = ref?.current?.scrollTop;
    setScrollPoint(scrollTop);
  }

  const scrollBarHeight =
    (ref?.current?.clientHeight / ref?.current?.scrollHeight) *
    ref?.current?.clientHeight;
  const top =
    (scrollPoint / (ref?.current?.scrollHeight - ref?.current?.clientHeight)) *
    (ref?.current?.clientHeight - scrollBarHeight);

  return (
    <Observer>
      {() => (
        <div>
          <PageTitle title={"Profile"} />
          {AuthStore.isLoadingFullScreen || !UserStore.isHydrated || loading ? (
            <LoadingScreen />
          ) : (
            <>
              <Header type="profile" />
              <div className="profile_main_outside">
                <div className="inside">
                  <div
                    className="profile_left_div"
                    style={{ position: "relative" }}
                  >
                    <PageHeading
                      headingClass="all_pages_head"
                      headingText="Profile"
                    />
                    <p className="blueTextColor">
                      Please select a family member to view their profile
                      details
                    </p>
                    <div style={{ position: "relative" }}>
                      <div
                        ref={ref}
                        className="set_list_container for_scroll"
                        onScroll={handleScrollStart}
                        style={{ position: "relative" }}
                      >
                        {ProfileStore2.mapUsersData?.map((data, index) => (
                          <div
                            className={
                              selectedSet.index !== index
                                ? ` set_list_item profile_padding not_selected `
                                : ` set_list_item profile_padding selected_list`
                            }
                            onClick={() =>
                              handleSelection(
                                data?.user_id,
                                data?.full_name,
                                data?.liasonOfficers?.[0]?.liasonOfficerId,
                                data,
                                index
                              )
                            }
                          >
                            {PerformanceStore.loaderClosingCheckForImage?.[
                              `${data.user_id}3`
                            ] &&
                            PerformanceStore.loaderClosingCheckForImage?.[
                              `${data.user_id}3`
                            ] === "pending" ? (
                              <div className="skeleton"></div>
                            ) : getDecodedToken()?.user_type !== "manager" &&
                              ProfileStore2.currentFamilyMembersImages?.[
                                data.user_id
                              ] ? (
                              <img
                                className="main_img"
                                src={
                                  ProfileStore2.currentFamilyMembersImages?.[
                                    data.user_id
                                  ]
                                }
                                alt={data.user_id}
                                aria-hidden="true"
                              />
                            ) : getDecodedToken()?.user_type === "manager" &&
                              data?.profile_pic ? (
                              <img
                                className="main_img"
                                src={UserStore.singleUsersUrl}
                                alt={data.user_id}
                                aria-hidden="true"
                              />
                            ) : (
                              <NoImage
                                data={data?.full_name?.[0]}
                                noImageClass={"no_image_component"}
                              />
                            )}

                            <h2
                              className={
                                selectedSet.userId !== data.user_id
                                  ? `profile_selected_tab itme_text blueTextColor`
                                  : `profile_not_selected_tab itme_text`
                              }
                            >
                              {data.full_name}
                            </h2>
                          </div>
                        ))}
                      </div>
                      <div
                        style={{
                          display: isTablet ? "block" : "none",
                          visibility: isNaN(top) ? "hidden" : "",
                          backgroundColor: "#DDE2EB",
                          height: scrollBarHeight,
                          width: 5,
                          borderRadius: 10,
                          position: "absolute",
                          top: top,
                          right: 5,
                        }}
                      />
                    </div>
                  </div>

                  <div className="profile_right_div">
                    <ProfileDetails
                      currentOpenAccordion={currentOpenAccordion}
                      handleAccordion={(data) => handleAccordion(data)}
                      selectedUser={selectedSet}
                      setSelectedSet={(data) =>
                        setSelectedSet({ ...selectedSet, userId: data })
                      }
                      data={selectedData}
                      userDetais={ProfileStore2.mapUsersData}
                      contactDetails={
                        ProfileStore2?.allUsersContact?.[selectedSet.index]
                      }
                      la_officer={
                        ProfileStore2?.liaisonOfficersContact?.[
                          selectedSet.index
                        ]
                      }
                      bankDetails={
                        ProfileStore2?.amountProfile?.[selectedSet.index]
                      }
                      setCurrenAccordionObject={setCurrenAccordionObject}
                      currenAccordionObject={currenAccordionObject}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </Observer>
  );
};

export default observer(Profile);
